import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMPrompt } from "../graphql/mutations";
import {
  CreateLLMPromptInput,
  CreateLLMPromptMutation,
} from "../API";

export async function createLLMPromptAfterEdit(
  values: CreateLLMPromptInput
):Promise<GraphQLResult<CreateLLMPromptMutation>> {
  return API.graphql(
    graphqlOperation(createLLMPrompt, {
      input: {
        name: values.name,
        status: values.status,
        projectId: values.projectId,
        key: values.key,
        description: values.description,
        prompt: values.prompt,
      },
    })
  ) as Promise<GraphQLResult<CreateLLMPromptMutation>>;
}
